<template>
    <ModalComponent
        name="enviar-abonos"
        title="Enviar abonos"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿ENVIAR TODOS LOS ABONOS?</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="enviarAbonos" :disabled="loading">SI, ENVIAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close() {
                this.$emit('close', 'enviar-abonos');
            },
            enviarAbonos() {
                this.loading = true;

                const params = {
                    filters : {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.abonos.enviar'), params).then(res => {
                    this.$toast.success("Abonos enviados");
                    this.close();
                }).finally(() => this.loading = false);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
